<template>
  <div class="side-frame">
    <div
      id="side-frame-view-header"
      :class="{ clickable: isSearchDialog && !isNotPaddyFieldItem }"
      @click="onClickHeader()"
    >
      <h4>
        <template v-if="isNotPaddyFieldItem"> ほ場外作業 </template>
        <template v-else>
          <img :src="flagSrc" />
          {{ paddyField.name }}
        </template>
      </h4>
    </div>
    <div class="side-frame-content">
      <div v-if="isNotPaddyFieldItem && !isSearchDialog" class="side-frame-row">
        {{ periodNotPaddyFieldItem }}
      </div>
      <div v-else-if="!isNotPaddyFieldItem" class="side-frame-content-header">
        <table>
          <tr>
            <td class="item-title">面積</td>
            <td>:</td>
            <td v-if="paddyField.area == null" class="item-value">
              {{ paddyField.area }}
            </td>
            <td v-else class="item-value">{{ paddyField.area }} (a)</td>
          </tr>
          <tr>
            <td class="item-title">品種</td>
            <td>:</td>
            <td class="item-value">{{ paddyField.brand }}</td>
          </tr>
          <tr>
            <td class="item-title">耕作者</td>
            <td>:</td>
            <td class="item-value">
              {{ paddyField.kousakusha }}
            </td>
          </tr>
        </table>
      </div>
      <div
        v-for="workHistory in workHistories"
        :key="workHistory.work_history_id"
      >
        <div
          class="side-frame-row view-header"
          :class="{ disabled: isReadOnly || isSearchDialog }"
          @click="onClickWorkHistory(workHistory)"
        >
          <div>
            <div
              class="mark col3-fill"
              :style="getHistorySeasonStyleObject(workHistory.season_id)"
            >
              {{ workHistory.season_name }}
            </div>
            <div
              class="mark col2-fill"
              :style="getHistoryItemStyleObject(workHistory.season_id)"
            >
              {{ workHistory.item_name }}
            </div>
          </div>
          <div id="edit-area">
            <span
              :class="{
                active: !isReadOnly,
                disabled: isReadOnly,
                disappear: isSearchDialog,
              }"
            ></span>
          </div>
        </div>
        <div class="work-histories">
          <table>
            <template v-for="workItemDetail in workHistory.work_items_merged">
              <tr :key="workItemDetail.item_detail_id">
                <td class="label">
                  {{ workItemDetail.item_detail_name }}
                </td>
                <td>:</td>
                <td
                  v-if="workItemDetail.item_detail_type === 'num'"
                  class="value"
                >
                  <span style="display:block">
                    {{ workItemDetail.value | addComma }}
                    &ensp;
                    {{ getItemDetailUnit(workItemDetail) }}
                  </span>
                  <template v-if="isItemDetailAuto(workItemDetail)">
                    <span style="display:block">
                      {{
                        getItemDetailAutoValue(
                          workItemDetail.item_detail_id,
                          workHistory
                        ) | addComma
                      }}
                      &ensp;
                      {{ getItemDetailAutoUnit(workItemDetail) }}
                    </span>
                  </template>
                </td>
                <td
                  v-else
                  class="value"
                  :class="{
                    value_textarea:
                      workItemDetail.item_detail_type === 'textarea',
                  }"
                >
                  {{ workItemDetail.value }}
                  &ensp;
                  {{ getItemDetailUnit(workItemDetail) }}
                </td>
              </tr>
            </template>
          </table>
          <div class="upload-image-view">
            <template v-for="(row, index) in workHistory.image_urls">
              <div
                :key="index"
                @click="onZoomImage(workHistory.image_paths[index])"
              >
                <img :src="row" />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- <div id="side-frame-view-footer"></div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  //TODO: タイミングしたいでnullだったりするのを直したい
  props: {
    paddyField: {
      type: Object,
    },
    workHistories: {
      required: true,
    },
    isNotPaddyFieldItem: {
      type: Boolean,
    },
    flagSrc: {
      type: String,
    },
    isReadOnly: {
      type: Boolean,
      required: true,
    },
    isSearchDialog: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      seasons: [],
    };
  },

  computed: {
    periodNotPaddyFieldItem() {
      if (this.isNotPaddyFieldItem) {
        if (this.workHistories && this.workHistories.length > 0) {
          let latest = this.workHistories[0].work_items_merged.find(
            (e) => e.display_flg === true
          ).value;
          const len = this.workHistories.length;
          let first = this.workHistories[len - 1].work_items_merged.find(
            (e) => e.display_flg === true
          ).value;
          return `${first} 〜 ${latest}`;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
  },

  filters: {
    addComma(val) {
      if (!val) {
        return val;
      }
      // 整数部のみカンマをつける
      const vals = val.toString().split(".");
      let ret = vals[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      if (vals.length > 1) {
        ret += "." + vals[1];
      }
      return ret;
    },
  },

  created() {
    this.seasons = this.getSeasons();
  },

  methods: {
    ...mapGetters(["getSeasons"]),

    onClickWorkHistory(workHistory) {
      this.$emit("clickWorkHistory", workHistory);
    },

    onZoomImage(path) {
      this.$emit("zoomImage", path);
    },

    getHistorySeasonStyleObject(seasonId) {
      const season = this.seasons.find((m) => m.season_id === seasonId);
      return {
        background: season.color,
      };
    },
    getHistoryItemStyleObject(seasonId) {
      const season = this.seasons.find((m) => m.season_id === seasonId);
      return {
        color: season.color,
      };
    },

    isItemDetailAuto(workItemDetail) {
      if (this.isNotPaddyFieldItem) {
        return false;
      }
      if (this.paddyField.area && workItemDetail.item_detail_auto) {
        return true;
      }
      return false;
    },

    getItemDetailAutoValue(itemDetailId, workHistory) {
      if (this.isNotPaddyFieldItem) {
        return "";
      }
      if (workHistory.work_items_auto) {
        const val = workHistory.work_items_auto[itemDetailId];
        if (val != null) {
          return val;
        }
      }
      return "";
    },

    getItemDetailUnit(workItemDetail) {
      let unit = workItemDetail.item_detail_unit;
      if (!unit) {
        unit = "";
      }
      return unit;
    },

    getItemDetailAutoUnit(workItemDetail) {
      if (this.isItemDetailAuto(workItemDetail)) {
        if (this.paddyField.area) {
          const unit = this.getItemDetailUnit(workItemDetail);
          return unit + "/10a";
        }
      }
      return "";
    },

    onClickHeader() {
      if (this.isSearchDialog && !this.isNotPaddyFieldItem) {
        this.$emit("clickHeader", this.paddyField);
      }
    },
  },
};
</script>

<style lang="scss">
.side-frame {
  padding: 0px;
  background: white;
  box-sizing: border-box;
  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.3);

  .mobile & {
    width: 100%;
    height: 100vh;
    box-shadow: unset;
  }

  h4 {
    font-size: 20px;
    text-align: center;
    font-weight: normal;
    margin: 0px auto 0;
    // padding: 0 0 0 2em;

    .mobile & {
      text-align: right;
      margin: 0;
    }

    &::before {
      white-space: pre;
      content: "    ";
      background: url("~@/assets/icons/ic_list.svg") no-repeat center center;
      margin: 0 10px 0 0;
    }
  }

  #side-frame-view-header {
    display: flex;
    align-items: center;
    width: 100%;
    height: 60px;
    padding: 10px;
    background: #ddd;
    box-sizing: border-box;
    position: sticky;
    top: 0;

    &.clickable {
      cursor: pointer;
    }

    .mobile & {
      display: grid;
      grid-template-columns: 1fr 32px;
      .btn-close {
        cursor: pointer;
        width: 32px;
        height: 32px;
        background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
        background-size: contain;
      }
    }

    h4 {
      font-size: 20px;
      text-align: center;
      font-weight: bold;
      margin: 0px auto 0;
      padding: 0 0 0 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .mobile & {
        text-align: left;
        margin: 0;
      }
    }
    img {
      display: inline-block;
      width: 20px;
      margin: 0 10px 0 0;
    }

    &.close {
      height: 0px;
      transition: ease-in-out 0.3s;
    }

    h4::before {
      content: "";
    }
  }

  #side-frame-view-footer {
    width: 100%;
    height: 40px;
    padding: 5px;
    background: #ddd;

    .mobile & {
      bottom: 0;
      position: fixed;
    }
  }

  .side-frame-content {
    box-sizing: border-box;

    .mobile & {
      max-height: calc(100vh - 100px);
    }

    .side-frame-content-header {
      overflow: auto;
      width: 100%;
      font-size: 15px;

      table {
        margin: auto;
        width: 100%;

        td {
          padding-right: 5px;
        }
        .item-title {
          text-align: right;
          width: 40%;
        }

        .item-value {
          min-width: 6rem;
        }
      }
    }
  }

  .side-frame-row {
    width: 100%;
    margin: 0 auto 0;
    /* min-height: 100px; */
    // border-bottom: solid 1px #ddd;
    border-top: solid 1px #ddd;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
  }

  .side-frame-row div {
    display: flex;
    align-items: center;
  }
  // .side-frame-row p {
  //   font-size: 15px;
  //   display: block;
  // }
  // .side-frame-row span {
  //   width: 25px;
  //   height: 45px;
  //   display: block;
  //   margin: 0 10px 0 0;
  // }

  .side-frame-row.view-header {
    cursor: pointer;
  }
  .side-frame-row.view-header.disabled {
    cursor: inherit;
    pointer-events: none;
  }

  // p.view-date {
  //   font-size: 18px;
  // }

  // TODO 不要なので削除
  .side-frame-content ul {
    font-size: 14px;
    color: #555;
    background: #f9f9f9;
    margin: 0;
    padding: 20px 20px 20px 40px;
  }

  .side-frame-content .work-histories {
    font-size: 14px;
    color: #555;
    background: #f9f9f9;
    padding: 5px 1rem;
    table {
      width: 100%;

      tr {
        line-height: 1.75rem;
        &:nth-of-type(n + 2) {
          border-top: solid 1px darkgray;
        }
      }
      td {
        padding-right: 5px;
      }
      .label {
        // min-width: 6rem;
        text-align: right;
        width: 40%;
        // &::after {
        //   content: "：";
        // }
      }
      .value {
        min-width: 6rem;
      }
      .value_number {
        text-align: right;
      }
      .value_textarea {
        white-space: pre-line;
      }
      .unit {
        word-break: keep-all;
      }
    }
  }

  .side-frame-row .mark {
    font-size: 12px;
    padding: 3px 9px;
    margin: 0 5px;
  }

  .btn-submit {
    display: block;
    background: var(--purple);
    font-size: 14px;
    text-align: center;
    width: 100px;
    height: 30px;
    border-radius: 15px;
    color: #fff;
    padding: 6px 20px;
    margin: 10px auto 10px;
    cursor: pointer;
    &.disable {
      opacity: 0.5;
      cursor: inherit;
      pointer-events: none;
    }
  }
  #edit-area {
    display: flex;
    justify-content: flex-end;
  }
  #edit-area span {
    display: block;
    font-size: 12px;
    padding: 3px 0px;
    margin: 10px 0;
    text-align: center;
    color: var(--purple);
    border-bottom: solid 4px transparent;
    opacity: 0.5;
    pointer-events: none;
  }

  #edit-area span.active {
    border-bottom: solid 4px var(--purple);
    opacity: 1;
    cursor: pointer;
    pointer-events: inherit;
  }
  #edit-area span.disabled {
    border-bottom: solid 4px var(--purple);
    opacity: 0.5;
    cursor: inherit;
  }
  #edit-area span.disappear {
    display: none;
  }

  #edit-area span::before {
    white-space: pre;
    content: "    ";
    background: url("~@/assets/icons/ic_edit.svg") no-repeat center center;
    background-size: 20px 20px;
    padding: 0 0 0 15px;
  }

  .upload-image-view {
    display: grid;
    grid-template-columns: 100px 100px 100px;

    div {
      text-align: center;
      margin: 2px;
      cursor: pointer;

      img {
        margin: auto;
        width: 100%;
        height: 100px; // .upload-image-view の grid-template-columns サイズに合わせる
        object-fit: contain; // fill | contain | cover | none | scale-down
        display: block;
      }
    }
  }
}
</style>
